/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../../clients/baseClient'
import type { RequestConfig, ResponseErrorConfig } from '../../../../clients/baseClient'
import type {
  GetListApiV1NotificationsFeedUserEventListGetQueryResponse,
  GetListApiV1NotificationsFeedUserEventListGetQueryParams,
  GetListApiV1NotificationsFeedUserEventListGetHeaderParams,
  GetListApiV1NotificationsFeedUserEventListGet422,
} from '../../types/GetListApiV1NotificationsFeedUserEventListGet.ts'
import type { InfiniteData, QueryKey, QueryClient, InfiniteQueryObserverOptions, UseInfiniteQueryResult } from '@tanstack/react-query'
import { infiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query'

export const getListApiV1NotificationsFeedUserEventListGetInfiniteQueryKey = (params?: GetListApiV1NotificationsFeedUserEventListGetQueryParams) =>
  [{ url: '/api/v1/notifications_feed_user_event/list/' }, ...(params ? [params] : [])] as const

export type GetListApiV1NotificationsFeedUserEventListGetInfiniteQueryKey = ReturnType<typeof getListApiV1NotificationsFeedUserEventListGetInfiniteQueryKey>

/**
 * @summary Get List
 * {@link /api/v1/notifications_feed_user_event/list/}
 */
export async function getListApiV1NotificationsFeedUserEventListGetInfinite(
  params?: GetListApiV1NotificationsFeedUserEventListGetQueryParams,
  headers?: GetListApiV1NotificationsFeedUserEventListGetHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetListApiV1NotificationsFeedUserEventListGetQueryResponse,
    ResponseErrorConfig<GetListApiV1NotificationsFeedUserEventListGet422>,
    unknown
  >({ method: 'GET', url: `/api/v1/notifications_feed_user_event/list/`, params, ...requestConfig, headers: { ...headers, ...requestConfig.headers } })
  return res.data
}

export function getListApiV1NotificationsFeedUserEventListGetInfiniteQueryOptions(
  params?: GetListApiV1NotificationsFeedUserEventListGetQueryParams,
  headers?: GetListApiV1NotificationsFeedUserEventListGetHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getListApiV1NotificationsFeedUserEventListGetInfiniteQueryKey(params)
  return infiniteQueryOptions<
    GetListApiV1NotificationsFeedUserEventListGetQueryResponse,
    ResponseErrorConfig<GetListApiV1NotificationsFeedUserEventListGet422>,
    GetListApiV1NotificationsFeedUserEventListGetQueryResponse,
    typeof queryKey,
    number
  >({
    queryKey,
    queryFn: async ({ signal, pageParam }) => {
      config.signal = signal

      if (params) {
        params['offset'] = pageParam as unknown as GetListApiV1NotificationsFeedUserEventListGetQueryParams['offset']
      }
      return getListApiV1NotificationsFeedUserEventListGetInfinite(params, headers, config)
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage, _allPages, lastPageParam) => (Array.isArray(lastPage) && lastPage.length === 0 ? undefined : lastPageParam + 1),
    getPreviousPageParam: (_firstPage, _allPages, firstPageParam) => (firstPageParam <= 1 ? undefined : firstPageParam - 1),
  })
}

/**
 * @summary Get List
 * {@link /api/v1/notifications_feed_user_event/list/}
 */
export function useGetListApiV1NotificationsFeedUserEventListGetInfinite<
  TData = InfiniteData<GetListApiV1NotificationsFeedUserEventListGetQueryResponse>,
  TQueryData = GetListApiV1NotificationsFeedUserEventListGetQueryResponse,
  TQueryKey extends QueryKey = GetListApiV1NotificationsFeedUserEventListGetInfiniteQueryKey,
>(
  params?: GetListApiV1NotificationsFeedUserEventListGetQueryParams,
  headers?: GetListApiV1NotificationsFeedUserEventListGetHeaderParams,
  options: {
    query?: Partial<
      InfiniteQueryObserverOptions<
        GetListApiV1NotificationsFeedUserEventListGetQueryResponse,
        ResponseErrorConfig<GetListApiV1NotificationsFeedUserEventListGet422>,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {},
) {
  const { query: { client: queryClient, ...queryOptions } = {}, client: config = {} } = options ?? {}
  const queryKey = queryOptions?.queryKey ?? getListApiV1NotificationsFeedUserEventListGetInfiniteQueryKey(params)

  const query = useInfiniteQuery(
    {
      ...getListApiV1NotificationsFeedUserEventListGetInfiniteQueryOptions(params, headers, config),
      queryKey,
      ...queryOptions,
    } as unknown as InfiniteQueryObserverOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, ResponseErrorConfig<GetListApiV1NotificationsFeedUserEventListGet422>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}